module.exports = __webpack_public_path__ + "static/3-a3c161d258899bd386d31edfd0ac6f76.jpg";